import ldGet from "lodash/get";
import ldMerge from "lodash/merge";
import ldSet from "lodash/set";

export function updateQuery<T, V>(updatePath: string) {
  return (
    previousQueryResult: T,
    {
      fetchMoreResult,
    }: {
      fetchMoreResult?: T;
      variables?: V;
    }
  ) => {
    if (!fetchMoreResult) {
      return previousQueryResult;
    }
    const previousResults = ldGet(previousQueryResult, updatePath, []);
    const newResults = ldGet(fetchMoreResult, updatePath, []);
    const merged = ldMerge({}, previousQueryResult, fetchMoreResult);
    return ldSet(merged, updatePath, previousResults.concat(newResults));
  };
}
